import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';
import { Tooltip } from '@mui/material';
import { FaEdit } from 'react-icons/fa';
import Select from 'react-select';
import { isEmpty } from '../../Services/config/globals';
import { UseStyles } from '../../components/TableStyles/tableSX';
import categoriesDropDownList from '../Categories/categoriesDropDownList';
import { requestStartUpList } from '../../Services/Utils/RequestStartupApis';
import { RequestStartupFilterSet } from '../../Services/Actions/CommonActions';

export const selectStyles = {
  control: (base) => ({
    ...base,
    border: '1px solid #CBCBCB',
    boxShadow: 'none',
    '&:hover': {
      border: '1px solid black',
    },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? '#DDDDDD' : 'white',
    color: '#000000',
  }),
};
export const selectOptionLabel = (e) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <img
      className="option-image"
      src={e.path}
      alt="icon"
      height="20px"
      width="20px"
    />
    <span style={{ marginLeft: 5, fontSize: 16 }}>{e.text}</span>
  </div>
);
export const statusOptions = [
  { id: 1, label: 'Open', value: 'open' },
  { id: 2, label: 'In Progress', value: 'In Progress' },
  { id: 3, label: 'Closed', value: 'Closed' },
];

function RequestStartUpList() {
  const classes = UseStyles();
  const dispatch = useDispatch();
  const filters = useSelector((state) => state.requestStartUpFilters);

  // table pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [itemOffset, setItemOffset] = useState(0);
  const [listRecordSize, setListRecordSize] = useState(0);
  const onPageChange = (event, newPage) => {
    setPage(newPage);
    const newOffset = (newPage * rowsPerPage) % listRecordSize;
    setItemOffset(newOffset);
  };
  const handleChangeRowsPerPage = (event) => {
    setrowsPerPage(event.target.value);
  };
  const [startUp, setStartUp] = useState([]);

  function startUpView() {
    const data = {};
    const params = {
      start: itemOffset,
      recordSize: rowsPerPage,
    };

    if (!isEmpty(inputValue)) {
      data.fullTextSearch = inputValue;
    }
    if (filters?.status) {
      data.status = { key: filters.status.id };
    }
    if (filters?.category) {
      data.categoryView = { id: filters.category.id };
    }

    requestStartUpList(data, params).then((res) => {
      setStartUp(res.list);
      setListRecordSize(res.records);
    });
  }
  useEffect(() => {
    startUpView();
  }, [itemOffset, rowsPerPage, filters]);

  // search startup
  const [inputValue, setInputValue] = useState('');
  const handleClickSearchBar = () => {
    startUpView();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      startUpView();
    }
  };

  return (
    <div>
      <div className="title-con">
        <div className="row align-items-center">
          <div className="col-sm-12 col-md-12 col-lg-3">
            <div className="title-left-con">
              <h6>Support</h6>
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-9">
            <div className="title-right-con list-ul-con">
              <ul>
                <li style={{ width: '250px' }}>
                  <Select
                    options={categoriesDropDownList()}
                    value={filters?.category}
                    className="react-select__container"
                    onChange={(e) => {
                      dispatch(RequestStartupFilterSet({ status: filters?.status, category: e }));
                    }}
                    isClearable="true"
                    placeholder="Category"
                    isSearchable={false}
                    getOptionLabel={selectOptionLabel}
                    styles={selectStyles}
                  />
                </li>
                <li style={{ width: '250px' }}>
                  <Select
                    options={statusOptions}
                    value={filters?.status}
                    className="react-select__container"
                    onChange={(e) => {
                      dispatch(RequestStartupFilterSet({ status: e, category: filters.category }));
                    }}
                    isClearable="true"
                    placeholder="Status"
                    isSearchable={false}
                  />
                </li>
                <li>
                  <div>
                    <Paper
                      sx={{
                        p: '2px 4px',
                        display: 'flex',
                        alignItems: 'center',
                        width: 300,
                      }}
                    >
                      <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        placeholder="search"
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e)}
                        value={inputValue}
                      />
                      <IconButton
                        type="button"
                        sx={{ p: '10px' }}
                        aria-label="search"
                        onClick={handleClickSearchBar}
                      >
                        <SearchIcon />
                      </IconButton>
                    </Paper>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {isEmpty(startUp) ? (
        <p
          className="text-center"
          style={{ marginTop: '100px' }}
        >
          No Data found
        </p>
      ) : (
        <div>
          <Paper sx={{ overflow: 'hidden', marginTop: '30px' }}>
            <TableContainer
              component={Paper}
              className="tableContainer"
              sx={{ maxHeight: 720, marginRight: 'auto' }}
            >
              <Table
                stickyHeader
                className={classes.root}
              >
                <TableHead>
                  <TableRow>
                    <TableCell width={60}>No.</TableCell>
                    <TableCell>Startup Name</TableCell>
                    <TableCell>Founder Name</TableCell>
                    <TableCell>Email ID</TableCell>
                    <TableCell>Category</TableCell>
                    <TableCell>Service Partner Name</TableCell>
                    <TableCell width={150}>Status</TableCell>
                    <TableCell width={100}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {startUp.map((startUpData, key) => (
                    <TableRow
                      key={key}
                      hover
                      tabIndex={-1}
                      className="muiTableRow"
                    >
                      <TableCell>{key + 1 + itemOffset}</TableCell>
                      <TableCell>{startUpData.userView.name}</TableCell>
                      <TableCell>{startUpData.userView.founderName}</TableCell>
                      <TableCell>{startUpData.userView.email}</TableCell>
                      <TableCell>{startUpData.categoryView.name}</TableCell>
                      <TableCell>{startUpData.serviceProviderName}</TableCell>
                      <TableCell>{startUpData.status?.value}</TableCell>
                      <TableCell>
                        <Tooltip title="Edit">
                          <Link
                            to={`/support-edit/${startUpData.id}`}
                            style={{ verticalAlign: 'text-bottom' }}
                          >
                            <FaEdit style={{ color: 'black', fontSize: '20px' }} />
                          </Link>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 20]}
              component="div"
              count={listRecordSize}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={onPageChange}
              onRowsPerPageChange={handleChangeRowsPerPage}
              className="tablepaginationcon"
            />
          </Paper>
        </div>
      )}
    </div>
  );
}

export default RequestStartUpList;
